import { Alert, Button } from '@mui/material'
import axios from 'axios';
import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom';

const EmailChanged = () => {

    const params = useParams()

    const user = JSON.parse(localStorage.getItem('user'))

    useEffect(() => {
      axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/auth/changeEmail/${params.userId}/${params.uniqueString}`)
      localStorage.removeItem("user", JSON.stringify(user))
    }, []);
  return (
    <div style={{height: '100vh'}}>
      <Alert severity="success" style={{height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <h3>Your email has been updated. You need to log in again to your account.</h3>
      </Alert>

      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px'}}>
        <Button variant="contained" style={{marginBottom: '20px', width: '100px'}}>
          <Link style={{textDecoration: 'none', color: '#fff', fontWeight: 'bold'}} to="/login">Login</Link>
        </Button>
      </div>

    </div>

  )
}

export default EmailChanged